export const formatarCep = (value = '') => {
  const numbers = String(value).replace(/\D/g, '').slice(0, 8);
  if (numbers.length <= 5) return numbers;
  return `${numbers.slice(0, 5)}-${numbers.slice(5)}`;
};

export const buscarEnderecoPorCep = async (cep) => {
  const digits = String(cep || '').replace(/\D/g, '');
  if (digits.length !== 8) return null;

  const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
  if (!response.ok) {
    throw new Error('Não foi possível consultar o CEP');
  }

  const data = await response.json();
  if (data.erro) {
    throw new Error('CEP não encontrado');
  }

  return {
    logradouro: data.logradouro || '',
    bairro: data.bairro || '',
    cidade: data.localidade || '',
    estado: data.uf || '',
    complemento: data.complemento || ''
  };
};
